import { CollegeService } from './../services/College_name.service';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, NgForm } from '@angular/forms';
import { AuthenticationService, Item, TestData, Category, Complexity, Type, DuplicateCollege } from '../services/authentication.service';
import { Router } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { TestSchedulerService } from '../services/test_scheduler.service';
import { QuestionSetService, QuestionSet, Pattern } from '../services/questionset.service';
import { TestTakerService } from '../services/test_taker.service';
import { MaterialModule } from '../material.module';
import {NgbTimepickerConfig, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerConfig} from '@ng-bootstrap/ng-bootstrap';
import {NgbTimeStruct} from '@ng-bootstrap/ng-bootstrap';
import { Schedule } from './scheduletest.model';
import * as moment from 'moment';
import { College_Names } from '../services/College_name.service';
import { YearService, Year } from '../services/year.service';
import { DatePipe } from '@angular/common';
import {formatDate} from '@angular/common';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule, MatSlideToggleChange} from '@angular/material';
import Swal from 'sweetalert2';
@Component({
  templateUrl: './scheduletest.component.html',
  styleUrls: ['./scheduletest.component.scss'],
  providers: [NgbTimepickerConfig,DatePipe]

})
export class ScheduleTestComponent implements OnInit {
  fieldArray: Array<Schedule> = [];
  newAttribute: any = {};
  start_time: NgbTimeStruct;
  end_time: NgbTimeStruct;
  date: NgbDateStruct;
  // date;
  selectedindex;
  model;
  result: boolean;
  details: boolean;
  fname;
  lname;
  user;
  result1: boolean;
  userAdmin: boolean;
  userSuperAdmin: boolean;
  userTestScheduler: boolean;
  userTestTaker: boolean;
  questionset: boolean;
  scheduletest: boolean;
  overall: boolean;
  mobileQuery: MediaQueryList;
  selectedquestionset;
  Pattern;
  evaluate: boolean;
  errpaper: boolean;
  errqstnset: boolean;
  errcandidate: boolean;
  errdate: boolean;
  errtime: boolean;
  todayDate:Date = new Date();
  today= new Date();
  todaysDataTime = '';
  past_time:boolean;
  isDetailsRequired:boolean=true;
  private _mobileQueryListener: () => void;
  dup_collegeid:DuplicateCollege = {collegeid:'',yearid:'',setid:''}
  test: TestData = {
    id: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Type: ''
  };
  question_set: QuestionSet = {
    Question_Set_Name: ''
  };
  college_set: College_Names={
    college_name:''
  }
  year_set: Year={
    academic_year:''
  }
  pattern: Pattern = {
    pattern: ''
  };

  scheduleTest = new FormGroup({
    college_name: new FormControl(''),
    academic_year:new FormControl(''),
    questionsetname: new FormControl(''),
    pattern: new FormControl(''),
    date: new FormControl(''),
    start_time: new FormControl(''),
    end_time: new FormControl('')
  });

  myForm: FormGroup;
  submitted: boolean = false;
  college: any;
  selectedcollegeset: any;
  Year: any;
  erracademic: boolean;
  errcollege: boolean;
  college_btn: boolean;
  year_btn: boolean;
  setname: boolean;
  datebtn: boolean;
  startbtn: boolean;
  endbtn: boolean;
  medium:boolean;
  low:boolean;
  high:boolean;
  myDate:any;
  minDate = undefined;
  todayTime: Date;
  start1: any;
  duplicate: boolean;
  yearid: any;
  errmedium: boolean;
  errhigh: boolean;
  errlow: boolean;
  userEvaluator: boolean;
  constructor(private fb: FormBuilder, private auth: AuthenticationService, private router: Router, private qs: QuestionSetService,
              private fs:CollegeService,private ys:YearService,private testtakerservice: TestTakerService, private testschedulerservice: TestSchedulerService,
              changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, config: NgbTimepickerConfig,private datePipe: DatePipe,private Config: NgbDatepickerConfig) {
                config.seconds = true;
                config.spinners = false;
                this.getAccess();
                this.simpletest();
                this.Questionset();
                this.College_Name();
                this.mobileQuery = media.matchMedia('(max-width: 600px)');
                this._mobileQueryListener = () => changeDetectorRef.detectChanges();
                this.mobileQuery.addListener(this._mobileQueryListener);
                this.createForm();
                this.myDate=formatDate(new Date(), 'yyyy/MM/dd', 'en');
                const current = new Date();
                this.minDate = {
                  year: current.getFullYear(),
                  month: current.getMonth() + 1,
                  day: current.getDate()
                };
  }
  ngOnInit() {
    this.getTempRowData();

  }


  getAccess(){
    this.user = sessionStorage.getItem('user');
    this.fname = sessionStorage.getItem('fname');
  
    this.lname = sessionStorage.getItem('lname');
  
  
    if (this.user === '1') {
      this.userAdmin = true;
      this.userTestScheduler = false;
      this.userEvaluator = false;
    } else if (this.user === '2') {
      this.userEvaluator = true;
      this.userAdmin = false;
      this.userTestScheduler = false;
    } else if (this.user === '3') {
      this.userTestScheduler = true;
      this.userAdmin = false;
      this.userEvaluator = false;  
    }
  }
  
    

  createForm() {
    this.myForm = this.fb.group({
       date: ['', [Validators.required]],
       start_time: ['', Validators.required],
       end_time: ['', Validators.required]
    });
  }

  get f() { return this.myForm.controls; }

   DateValidator(format = 'MM/dd/YYYY'): any {
    return (control: FormControl): { [key: string]: any } => {
      const val = moment(control.value, format, true);

      if (!val.isValid()) {
        return { invalidDate: true };
      }

      return null;
    };
  }

  simpletest() {
    this.testschedulerservice.test_scheduler(this.test).subscribe(
    (data) => {

     this.user = sessionStorage.getItem('user');
     this.fname = sessionStorage.getItem('fname');

     this.lname = sessionStorage.getItem('lname');


    },
    err => {
      console.error(err);
    }
  );
  }
  cancel(){
    this.router.navigate(['scheduled_test_view']);
  }

  Questionset() {
    console.log("this.question_set******",this.question_set);
    this.qs.question_set_display(this.question_set).subscribe(
      (data) => {

        this.result = data.results;
console.log("this.result ",this.result );

      },
      err => {
        console.error(err);
      }
    );

    // this.testtakerservice.test_taker(this.test).subscribe(
    //   (data) => {
    //
    //    this.result1 = data.results;
    //
    //

    //   }
    //);
  }

  College_Name() {
    this.fs.College_Name(this.college_set).subscribe(
      (data) => {

        this.college = data.results;


      },
      err => {
        console.error(err);
      }
    );

    // this.testtakerservice.test_taker(this.test).subscribe(
    //   (data) => {
    //
    //    this.result1 = data.results;
    //
    //

    //   }
    // );
  }

  mediumWeightageHandler(event: any, i: any,field : any){
    let sample = field.medium_weightage;
    console.log("sample",sample)
    this.fieldArray[i].medium_weightage = sample
  }

  lowWeightageHandler(event: any, i: any,field : any){
    let sample = field.low_weightage;
    console.log("sample",sample)
    this.fieldArray[i].low_weightage = sample

  }

  highWeightageHandler(event: any, i: any,field : any){
    let sample = field.high_weightage;
    console.log("sample",sample)
    this.fieldArray[i].high_weightage = sample

  }

  selectChangeHandler(event: any, i: any) {

    this.selectedindex = i;

    this.selectedquestionset = event.target.value;

    this.qs.pattern(this.selectedquestionset).subscribe(
             (data) => {

              this.Pattern = data.results;
              this.fieldArray[i].paperlist = data.results;


             },
                   err => {
                     console.error(err);
                   }
             );
     }
     selectChangeHandler1(event: any, i: any) {

      this.selectedindex = i;

      this.selectedcollegeset = event.target.value;

      this.ys.academicyear(this.selectedcollegeset).subscribe(
               (data) => {

                this.Year = data.results;
                this.fieldArray[i].academic_year = data.results;


                this.yearid=this.Year[0].Id
               },
                     err => {
                       console.error(err);
                     }
               );
       }

     getTempRowData() {
      this.newAttribute = { college_name:'', academic_year:'', questionsetname: '', pattern: '', date: '', start_time: '', end_time:'', paperlist: '', scheduler: '',low_weightage:1,medium_weightage:1,high_weightage:1};
      this.fieldArray.push(this.newAttribute);
    }
    add() {
      this.getTempRowData();
    }

    deleteFieldValue(index) {
      this.fieldArray.splice(index, 1);
    }
    create_next(){
      console.log("create_next",this.fieldArray)
      var todayTime =  new Date();
      let self = this;
      var date = new Date();
      this.todaysDataTime = formatDate(this.today, 'hh:mm:ss', 'en-US', '+0530');
      JSON.stringify(todayTime)
      var time=  this.fieldArray[0].date
      var start = this.fieldArray[0].start_time
      var end = this.fieldArray[0].end_time

      function compareDays(dateObj,hour){
        // alert("inside func")
        self.start1=new Date(dateObj.year+'-'+dateObj.month+"-"+dateObj.day+
        " "+ hour.hour +":" + hour.minute + ":" + hour.second + "+0530");





        if ((date.getTime() / 1000) > (self.start1.getTime() / 1000)) {
          //alert("select crt time")
             self.past_time=true

        }
        else{
          self.past_time=false;

        }
     }

      compareDays(time,start)



      // var dates = formatDate(this.fieldArray[0].date, 'yyyy/MM/dd', 'en');
      // alert(dates)

 if(this.fieldArray[0].low_weightage == '' || this.fieldArray[0].low_weightage == null){
  console.log("inside low not filled")
        this.low=true;
      }
      else{
        this.low=false;
      }
      if(this.fieldArray[0].medium_weightage == '' || this.fieldArray[0].medium_weightage == null){
        console.log("inside medium not filled")

        this.medium=true;
      }
      else{
        this.medium=false;
      }
      if(this.fieldArray[0].high_weightage == '' || this.fieldArray[0].high_weightage == null){
        console.log("inside high not filled")

        this.high=true;
      }
      else{
        this.high=false;
      }

      if(this.fieldArray[0].college_name == ''){
        this.college_btn=true;
      }
      else{
        this.college_btn=false;
      }
      if(this.fieldArray[0].academic_year==''){
        this.year_btn=true;
      }
      else{
        this.year_btn=false;
      }
      if(this.fieldArray[0].questionsetname==''){
        this.setname=true
      }
      else{
        this.setname=false;
      }
      if(this.fieldArray[0].date==''){
        this.datebtn=true
      }
      else{
        this.datebtn=false;
      }
      if(this.fieldArray[0].date==''){
        this.datebtn=true
      }
      if(this.fieldArray[0].start_time=='' || this.fieldArray[0].start_time < '0' || this.fieldArray[0].start_time===null){
        this.startbtn=true
      }
      else{
        this.startbtn=false
      }
      if(this.fieldArray[0].end_time < '0' || this.fieldArray[0].start_time=='' || this.fieldArray[0].start_time===null){
        this.endbtn=true
      }
      else{
        this.endbtn=false
      }
      // if(start.new Date("month day year hour:min:sec")  >=  todayTime{
      //   alert("wrong time")
      // }

      console.log("******",this.low,this.medium,this.high)

      if((  this.endbtn && this.startbtn && this.datebtn && this.setname && this.college_btn && this.year_btn )===false)
      {
        if( this.low === false && this.medium === false && this.high === false){
        console.log("inside all false")
        if(this.past_time  === false)
        {

          if(this.duplicate === false)
          {
            this.schedule()
          }
        }


      }
    }
    }

    duplicate_collegename(){
      this.dup_collegeid.collegeid=this.selectedcollegeset
      this.dup_collegeid.yearid=this.yearid
      this.dup_collegeid.setid=this.selectedquestionset;
      this.auth.duplicatecollege(this.dup_collegeid).subscribe(
        (data) => {

          if(data.code==204)
         {
             this.duplicate=true
         }
          else{
            this.duplicate=false;
         }
         this.create_next()
        },
              err => {
                console.error(err);
              }
        );
    }
    schedule() {
      this.fieldArray[0].isDetailsRequired=this.isDetailsRequired
      console.log('field***',this.fieldArray)
      localStorage.setItem('field',JSON.stringify(this.fieldArray))


      for (let i = 0; i <= this.fieldArray.length; i++ ) {
        if (this.fieldArray[i].college_name > '0') {

          if (this.fieldArray[i].academic_year > '0') {

          if (this.fieldArray[i].questionsetname > '0') {

            // if (this.fieldArray[i].pattern > '0') {
            //
              if (this.fieldArray[i].date > '0') {

                if (this.fieldArray[i].start_time > '0') {


                  if (this.fieldArray[i].end_time > '0') {

                    if (this.fieldArray[i].low_weightage > '0') {

                      if (this.fieldArray[i].high_weightage > '0') {

                        if (this.fieldArray[i].medium_weightage > '0') {


                  this.qs.schedule(this.fieldArray).subscribe(
                            (data) => {
                              this.submitted = true;

                              if (data.code === 200) {
                                
                                Swal.fire({
                                  title: 'Success',
                                  text: data.success,
                                  icon: 'success',
                                  showCancelButton: false,
                                  confirmButtonText: 'OK'
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    this.router.navigateByUrl('/scheduled_test_view');
                                  }
                                })
                              }else if (data.code === 400) {
                                Swal.fire({
                                  title: 'Alert',
                                  text: data.failed,
                                  icon: 'warning',
                                  showCancelButton: false,
                                  confirmButtonText: 'OK'
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    // this.router.navigateByUrl('/test_scheduler');
                                  }
                                })
                      
                              }

                            },
                            err => {
                              console.error(err);
                            }
                          );

                }else if (this.fieldArray[i].medium_weightage === '') {

                  this.errmedium = true;
                }}else if (this.fieldArray[i].high_weightage === '') {

                  this.errhigh = true;
                }}else if (this.fieldArray[i].low_weightage === '') {

                  this.errlow = true;
                }}
                
                else if (this.fieldArray[i].end_time === '') {

                    this.errtime = true;
                  }
                } else if (this.fieldArray[i].start_time === '') {

                  this.errtime = true;
                }
                } else if (this.fieldArray[i].date === '') {

                  this.errdate = true;

              }

          } else if (this.fieldArray[i].questionsetname === '') {

            this.errqstnset = true;
          }
        } else if (this.fieldArray[i].academic_year === '') {

          this.erracademic = true;
        }
        } else if (this.fieldArray[i].college_name === '') {

          this.errcollege = true;
        }
      }

    }

    onChangeDetailsRequired(event: MatSlideToggleChange,i:any) {
      const isChecked = event?.source?.checked;
      this.isDetailsRequired = isChecked == true ? true : false
      console.log("this.isDetailsRequird ",this.isDetailsRequired )
      this.fieldArray[i].isDetailsRequired = this.isDetailsRequired
      console.log(this.fieldArray,"fieldArray")
   
    }
    
}
